module.exports = __webpack_public_path__ + "static/media/nextStep.be34b406.mp3";